var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createAction, createReducer } from '@reduxjs/toolkit';
import * as statuses from 'services/store/states';
import * as types from './types';
var initialState = {
    status: statuses.IDLE,
    user: null,
    isUpdating: false,
    error: null,
    file: {
        status: statuses.IDLE,
        data: [],
        error: null,
    },
    answers: {
        status: statuses.IDLE,
        data: null,
        error: null,
    },
};
var fetch = createAction(types.KYC_USER_FETCH_REQUEST);
var fetchSuccess = createAction(types.KYC_USER_FETCH_SUCCESS);
var fetchFail = createAction(types.KYC_USER_FETCH_FAIL);
var update = createAction(types.KYC_USER_UPDATE_REQUEST);
var updateSuccess = createAction(types.KYC_USER_UPDATE_SUCCESS);
var updateFail = createAction(types.KYC_USER_UPDATE_FAIL);
var fetchFiles = createAction(types.KYC_USER_FILES_REQUEST);
var fetchFilesSuccess = createAction(types.KYC_USER_FILES_SUCCESS);
var fetchFilesFail = createAction(types.KYC_USER_FILES_FAIL);
var updateFile = createAction(types.KYC_USER_FILE_UPDATE_REQUEST);
var updateFileSuccess = createAction(types.KYC_USER_FILE_UPDATE_SUCCESS);
var updateFileFail = createAction(types.KYC_USER_FILE_UPDATE_FAIL);
var fetchAnswers = createAction(types.KYC_USER_ANSWERS_REQUEST);
var fetchAnswersSuccess = createAction(types.KYC_USER_ANSWERS_SUCCESS);
var fetchAnswersFail = createAction(types.KYC_USER_ANSWERS_FAIL);
var updateAnswers = createAction(types.KYC_USER_ANSWERS_UPDATE_REQUEST);
var updateAnswersSuccess = createAction(types.KYC_USER_ANSWERS_UPDATE_SUCCESS);
var updateAnswersFail = createAction(types.KYC_USER_ANSWERS_UPDATE_FAIL);
var kycUserReducer = createReducer(initialState, function (builder) {
    builder
        .addCase(fetch, function (state) { return (__assign(__assign({}, state), { status: statuses.LOADING })); })
        .addCase(fetchSuccess, function (state, action) { return (__assign(__assign({}, state), { status: statuses.SUCCESS, user: action.payload })); })
        .addCase(fetchFail, function (state) { return (__assign(__assign({}, state), { status: statuses.FAIL })); })
        .addCase(update, function (state) { return (__assign(__assign({}, state), { isUpdating: true })); })
        .addCase(updateSuccess, function (state, action) { return (__assign(__assign({}, state), { isUpdating: false, user: action.payload })); })
        .addCase(updateFail, function (state, action) { return (__assign(__assign({}, state), { isUpdating: false, error: action.payload })); })
        .addCase(fetchFiles, function (state) { return (__assign(__assign({}, state), { file: __assign(__assign({}, state.file), { status: statuses.LOADING }) })); })
        .addCase(fetchFilesSuccess, function (state, action) { return (__assign(__assign({}, state), { file: __assign(__assign({}, state.file), { status: statuses.SUCCESS, data: action.payload }) })); })
        .addCase(fetchFilesFail, function (state, action) { return (__assign(__assign({}, state), { file: __assign(__assign({}, state.file), { status: statuses.FAIL, error: action.payload }) })); })
        .addCase(updateFile, function (state) { return (__assign(__assign({}, state), { file: __assign(__assign({}, state.file), { status: statuses.LOADING, error: null }) })); })
        .addCase(updateFileSuccess, function (state, action) { return (__assign(__assign({}, state), { file: __assign(__assign({}, state.file), { status: statuses.SUCCESS, data: (state.file.data
                && state.file.data.map(function (file) { return file.type; }).includes(action.payload.type))
                ? state.file.data.map(function (file) {
                    if (file.type === action.payload.type) {
                        return action.payload;
                    }
                    return file;
                })
                : __spreadArray(__spreadArray([], (state.file.data || []), true), [action.payload], false) }) })); })
        .addCase(updateFileFail, function (state, action) { return (__assign(__assign({}, state), { file: __assign(__assign({}, state.file), { status: statuses.FAIL, error: action.payload }) })); })
        .addCase(fetchAnswers, function (state) { return (__assign(__assign({}, state), { answers: __assign(__assign({}, state.answers), { status: statuses.LOADING }) })); })
        .addCase(fetchAnswersSuccess, function (state, action) { return (__assign(__assign({}, state), { answers: __assign(__assign({}, state.answers), { status: statuses.SUCCESS, data: action.payload }) })); })
        .addCase(fetchAnswersFail, function (state) { return (__assign(__assign({}, state), { answers: __assign(__assign({}, state.answers), { status: statuses.FAIL }) })); })
        .addCase(updateAnswers, function (state) { return (__assign(__assign({}, state), { answers: __assign(__assign({}, state.answers), { status: statuses.LOADING }) })); })
        .addCase(updateAnswersSuccess, function (state, action) { return (__assign(__assign({}, state), { answers: __assign(__assign({}, state.answers), { status: statuses.SUCCESS, data: action.payload }) })); })
        .addCase(updateAnswersFail, function (state) { return (__assign(__assign({}, state), { answers: __assign(__assign({}, state.answers), { status: statuses.FAIL }) })); });
});
export default kycUserReducer;
